<template>
    <div class="setup-container">
        <div class="header-search">
            <div class="search-bar">
                <Search />
                <input type="text" placeholder="Search..." v-model="searchQuery" />
            </div>
        </div>
        <div>
            <p class="application-title">My Profile</p>
        </div>
        <!-- Table -->
        <table class="table">
            <thead>
                <tr>
                    <th>#</th>
                    <th>Application ID</th>
                    <th>Member ID</th>
                    <th>Fullname</th>
                    <th>Phone</th>
                    <th>Email</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in paginatedData" :key="item.id">
                    <td>{{ (currentPage - 1) * pageSize + index + 1 }}</td>
                    <td>{{ item.application_id }}</td>
                    <td>{{ item.memberId }}</td>
                    <td>{{ item.lastname }} {{ item.firstname }} {{ item.othernames }}</td>
                    <td>{{ item.phone }}</td>
                    <td>{{ item.email }}</td>
                    <td class="actions">
                        <button @click="viewItem(item)" class="btn view">
                            <Eye class="icon" />
                        </button>
                        <button @click="editItem(item)" class="btn view">
                            <PenLine class="icon" />
                        </button>
                    </td>
                   
                </tr>
            </tbody>
        </table>

        <!-- Pagination -->
        <div class="pagination">
            <button @click="prevPage" :disabled="currentPage === 1">
                <ChevronLeft />
            </button>
            <button v-for="page in totalPages" :key="page" @click="goToPage(page)"
                :class="{ active: currentPage === page }">
                {{ page }}
            </button>
            <button @click="nextPage" :disabled="currentPage === totalPages">
                <ChevronRight />
            </button>
        </div>
    </div>
    <div
        v-if="showModal"
        class="modal fade show"
        style="display: block; background: rgba(0, 0, 0, 0.6);"
        @click.self="closeModal"
        >
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content rounded-3 shadow-lg border-0">
            <!-- Header -->
            <div class="modal-header bg-primary text-white rounded-top">
              <h5 class="modal-title fw-bold">
                <i class="fa fa-id-card me-2"></i> Profile Details
              </h5>
              <button type="button" class="btn-close btn-close-white" @click="closeModal"></button>
            </div>

            <!-- Body -->
            <div class="modal-body p-4">
              <div v-if="selectedItem">
                <!-- Applicant Information -->
                <h6 class="fw-bold mb-3 border-bottom pb-2 text-secondary">
                  User Information
                </h6>
                <img style="border-radius: 4px;" :src="base_url + selectedItem.passport" width="150px" height="150px" alt="">
                <div class="row g-3 mb-4 mt-2">
                  <div class="col-md-4">
                    <label class="fw-semibold text-muted">First Name</label>
                    <p class="text-dark mb-0">{{ selectedItem.firstname }}</p>
                  </div>
                  <div class="col-md-4">
                    <label class="fw-semibold text-muted">Last Name</label>
                    <p class="text-dark mb-0">{{ selectedItem.lastname }}</p>
                  </div>
                  <div class="col-md-4">
                    <label class="fw-semibold text-muted">Other Name</label>
                    <p class="text-dark mb-0">{{ selectedItem.othernames }}</p>
                  </div>
                  <div class="col-md-4">
                    <label class="fw-semibold text-muted">Email</label>
                    <p class="text-dark mb-0">{{ selectedItem.email }}</p>
                  </div>
                  <div class="col-md-4">
                    <label class="fw-semibold text-muted">Phone</label>
                    <p class="text-dark mb-0">{{ selectedItem.phone }}</p>
                  </div>
                  <div class="col-md-4">
                    <label class="fw-semibold text-muted">Address</label>
                    <p class="text-dark mb-0">{{ selectedItem.address }}</p>
                  </div>
                </div>

                <!-- Application Details -->
                <h6 class="fw-bold mb-3 border-bottom pb-2 text-secondary">
                  Application Details
                </h6>
                <div class="row g-3 mb-4">
                  <div class="col-md-4">
                    <label class="fw-semibold text-muted">Application ID</label>
                    <p class="text-dark mb-0">{{ selectedItem.application_id }}</p>
                  </div>
                  <div class="col-md-4">
                    <label class="fw-semibold text-muted">Member ID</label>
                    <p class="text-dark mb-0">{{ selectedItem.memberId }}</p>
                  </div>
                  <div class="col-md-4">
                    <label class="fw-semibold text-muted">Profession</label>
                    <p class="text-dark mb-0">{{ selectedItem.profession }}</p>
                  </div>
                  <div class="col-md-4">
                    <label class="fw-semibold text-muted">Employer</label>
                    <p class="text-dark mb-0">{{ selectedItem.employer }}</p>
                  </div>
                  <div class="col-md-4">
                    <label class="fw-semibold text-muted">Employer Address</label>
                    <p class="text-dark mb-0">{{ selectedItem.empl_office_address }}</p>
                  </div>
                  <div class="col-md-4">
                    <label class="fw-semibold text-muted">Employer Phone</label>
                    <p class="text-dark mb-0">{{ selectedItem.empl_office_phone }}</p>
                  </div>

                  <div class="col-md-4">
                    <label class="fw-semibold text-muted">Nature of Business</label>
                    <p class="text-dark mb-0">{{ selectedItem.work_status }}</p>
                  </div>
                  <div class="col-md-4">
                    <label class="fw-semibold text-muted">Present Membership</label>
                    <p class="text-dark mb-0">{{ selectedItem.other_club_membership }}</p>
                  </div>
                  <div class="col-md-4">
                    <label class="fw-semibold text-muted">Expelled?</label>
                    <p class="text-dark mb-0">{{ selectedItem.expelled }}</p>
                  </div>

                  <div class="col-md-4">
                    <label class="fw-semibold text-muted">Expelled Reason?</label>
                    <p class="text-dark mb-0">{{ selectedItem.reason_expelled }}</p>
                  </div>

                  <!-- Game Interest -->
                <h6 class="fw-bold mb-3 border-bottom pb-2 text-secondary">
                Game Interest
                </h6>
                <div class="row g-0 mb-0">
                <div class="col-md-12">
                    <ul class="list-inline mb-0">
                    <li
                        v-for="(game, index) in parsedGameInterest"
                        :key="index"
                        class="badge bg-info text-dark me-2 mb-0 px-3 py-2 rounded-pill"
                    >
                        {{ game }}
                    </li>
                    </ul>
                </div>
                </div>

                  

                </div>

                <!-- Children -->
                <h6 class="fw-bold mb-3 border-bottom pb-2 text-secondary">
                  Children
                </h6>
                <div class="table-responsive mb-4">
                  <table class="table table-sm table-striped align-middle">
                    <thead class="table-light">
                      <tr>
                        <th>Name</th>
                        <th>Sex</th>
                        <th>Date of Birth</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(child, index) in parsedChildren" :key="index">
                        <td>{{ child.name }}</td>
                        <td>{{ child.sex }}</td>
                        <td>{{ child.dob }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Sponsors -->
                <h6 class="fw-bold mb-3 border-bottom pb-2 text-secondary">
                  Sponsor Information
                </h6>
                <div class="row g-3 mb-4">
                  <div class="col-md-6">
                    <label class="fw-semibold text-muted">First Sponsor</label>
                    <p class="text-dark mb-0">
                      {{ selectedItem.first_sponsor_firstname }} {{ selectedItem.first_sponsor_lastname }}
                      <br />
                      <small class="text-muted">Member ID: {{ selectedItem.first_sponsorId }}</small>
                      <br />
                      <small class="text-muted">Approval Status: <span class="text-warning">{{ selectedItem.sponsor_approval }}</span></small>
                    </p>
                  </div>
                  <div class="col-md-6">
                    <label class="fw-semibold text-muted">Second Sponsor</label>
                    <p class="text-dark mb-0">
                      {{ selectedItem.second_sponsor_firstname }} {{ selectedItem.second_sponsor_lastname }}
                      <br />
                      <small class="text-muted">Member ID: {{ selectedItem.second_sponsorId }}</small>
                      <br />
                      <small class="text-muted">Approval Status: <span class="text-warning">{{ selectedItem.sponsor_approval2 }}</span></small>
                    </p>
                  </div>
                </div>

                <!-- Executives -->
                <h6 class="fw-bold mb-3 border-bottom pb-2 text-secondary">
                  Executive Information
                </h6>
                <div class="row g-3 mb-4">
                  <div class="col-md-6">
                    <label class="fw-semibold text-muted">First Executive</label>
                    <p class="text-dark mb-0">
                      {{ selectedItem.first_executive_firstname }} {{ selectedItem.first_executive_lastname }}
                      <br />
                      <small class="text-muted">Member ID: {{ selectedItem.first_executiveId }}</small>
                      <br />
                      <small class="text-muted">Approval Status: <span class="text-warning">{{ selectedItem.executive_member_approval }}</span></small>
                    </p>
                  </div>
                  <div class="col-md-6">
                    <label class="fw-semibold text-muted">Second Executive</label>
                    <p class="text-dark mb-0">
                      {{ selectedItem.second_executive_firstname }} {{ selectedItem.second_executive_lastname }}
                      <br />
                      <small class="text-muted">Member ID: {{ selectedItem.second_executiveId }}</small>
                      <br />
                      <small class="text-muted">Approval Status: <span class="text-warning">{{ selectedItem.executive_approval2 }}</span></small>
                    </p>
                  </div>
                </div>

                <!-- Documents -->
                <h6 class="fw-bold mb-3 border-bottom pb-2 text-secondary">
                  Document Information
                </h6>
                <div class="row g-3 mb-4">
                  <div class="col-md-4" v-if="selectedItem.bank_statement">
                    <label class="fw-semibold text-muted">6 months personal or company statement</label>
                    <a :href="base_url + selectedItem.bank_statement" target="_blank" class="text-primary d-block text-decoration-none">
                      View File
                    </a>
                  </div>
                  <div class="col-md-4" v-if="selectedItem.means_identification">
                    <label class="fw-semibold text-muted">Valid Means of Identification</label>
                    <a :href="base_url + selectedItem.means_identification" target="_blank" class="text-primary d-block text-decoration-none">
                      View File
                    </a>
                  </div>
                  <div class="col-md-4" v-if="selectedItem.recent_utility">
                    <label class="fw-semibold text-muted">Recent Utility Bill</label>
                    <a :href="base_url + selectedItem.recent_utility" target="_blank" class="text-primary d-block text-decoration-none">
                      View File
                    </a>
                  </div>
                </div>

                <!-- Signature -->
                <h6 class="fw-bold mb-3 border-bottom pb-2 text-secondary">
                  Signature
                </h6>
                <div class="text-center">
                  <img
                    v-if="selectedItem.signature"
                    :src="base_url + selectedItem.signature"
                    alt="Signature"
                    class="img-fluid border rounded shadow-sm"
                    style="max-width: 300px;"
                  />
                  <p class="mt-2 text-muted">
                    <strong>Name:</strong> {{ selectedItem.signature_name }}
                  </p>
                  <p class="text-muted">
                    <strong>Date Submitted:</strong> {{ selectedItem.submit_date }}
                  </p>
                </div>
              </div>
            </div>

            <!-- Footer -->
            <div class="modal-footer bg-light d-flex justify-content-end gap-2">
              <button class="btn btn-secondary" @click="closeModal">
                <i class="fa fa-times me-1"></i> Close
              </button>
            </div>
          </div>
        </div>
    </div>
    <div
    v-if="showEditModal"
    class="modal fade show"
    style="display: block; background: rgba(0, 0, 0, 0.6);"
    @click.self="closeEditModal"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content rounded-3 shadow-lg border-0">
        <!-- Header -->
        <div class="modal-header bg-primary text-white rounded-top">
          <h5 class="modal-title fw-bold">
            <i class="fa fa-id-card me-2"></i> Edit Profile
          </h5>
          <button type="button" class="btn-close btn-close-white" @click="closeEditModal"></button>
        </div>

        <!-- Body -->
        <div class="modal-body p-4">
          <div v-if="selectedItem">
            <!-- Applicant Information -->
            <h6 class="fw-bold mb-3 border-bottom pb-2 text-secondary">
              Profile
            </h6>
            <div style="display: flex; flex-direction: column;  align-items: center;">
              <img style="border-radius: 4px;" :src="base_url + selectedItem.passport" width="150px" height="150px" alt="">
              <span class="text-success">{{ updateMessga }}</span>
              <input type="file" @change="uploadProfileImage" class="form-control" accept="image/*" />
            </div>
            <div class="row g-3 mb-4">
              <div class="col-md-4">
                <label class="fw-semibold text-muted">First Name</label>
                <input 
                  type="text" 
                  class="form-control" 
                  v-model="selectedItem.firstname"
                  placeholder="First Name"
                >
              </div>
              <div class="col-md-4">
                <label class="fw-semibold text-muted">Last Name</label>
                <input 
                  type="text" 
                  class="form-control" 
                  v-model="selectedItem.lastname"
                  placeholder="Last Name"
                >
              </div>
              <div class="col-md-4">
                <label class="fw-semibold text-muted">Other Name</label>
                <input 
                  type="text" 
                  class="form-control" 
                  v-model="selectedItem.othernames"
                  placeholder="Other Name"
                >
              </div>
              <div class="col-md-4">
                <label class="fw-semibold text-muted">Email</label>
                <input 
                  type="email" 
                  class="form-control" 
                  v-model="selectedItem.email"
                  readonly
                  placeholder="Email"
                >
              </div>
              <div class="col-md-4">
                <label class="fw-semibold text-muted">Phone</label>
                <input 
                  type="tel" 
                  class="form-control" 
                  v-model="selectedItem.phone"
                  placeholder="Phone"
                >
              </div>
              <div class="col-md-4">
                <label class="fw-semibold text-muted">Address</label>
                <textarea 
                  class="form-control" 
                  v-model="selectedItem.address"
                  placeholder="Address"
                  rows="2"
                ></textarea>
              </div>
            </div>

            <h6 class="fw-bold mb-3 border-bottom pb-2 text-secondary">
              Edit Password
            </h6>
          
            <div class="row g-3 mb-4">
              <div class="col-md-4">
                <label class="fw-semibold text-muted">Previous Password</label>
                <input 
                  type="password" 
                  class="form-control" 
                  v-model="selectedItem.prePassword"
                  placeholder="Enter previous password"
                >
              </div>
              <div class="col-md-4">
                <label class="fw-semibold text-muted">Current Password</label>
                <input 
                  type="password" 
                  class="form-control" 
                  v-model="selectedItem.currentPassword"
                  placeholder="Enter current password"
                >
              </div>
              <div class="col-md-4">
                <label class="fw-semibold text-muted">Confirm password</label>
                <input 
                  type="password" 
                  class="form-control" 
                  v-model="selectedItem.confirmPassword"
                  placeholder="Confirm password"
                >
              </div>

            </div>

          </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer bg-light d-flex justify-content-end gap-2">
          <button class="btn btn-success" @click="updateData">
            <i class="fa fa-save me-1"></i> Update
          </button>
          <button class="btn btn-secondary" @click="closeEditModal">
            <i class="fa fa-times me-1"></i> Close
          </button>
        </div>
      </div>
    </div>
</div>

</template>

<script setup>
/* eslint-disable */ 

import { ArrowUpRight, ChevronLeft, Eye, ChevronRight, PenLine, Search, Trash } from "lucide-vue-next";
import { ref, computed, onMounted, onBeforeUnmount } from "vue";
import axios from 'axios';

const dataList = ref([]);
const showModal = ref(false);
const showEditModal = ref(false);
const selectedItem = ref(null);
let base_url = process.env.VUE_APP_BASE_LIVE_URL
//let base_url = "http://localhost:8888/lltc_backend/"

// Pagination state
const currentPage = ref(1);
const pageSize = 8;
const username = ref(localStorage.getItem('username'));
const updateMessga = ref('');

onMounted( async () => {
  await listRecords();
  
});

onBeforeUnmount( async () => {
  
});

// Computed values
const totalPages = computed(() =>
    Math.ceil(dataList.value.length / pageSize)
);

const parsedGameInterest = computed(() => {
  try {
    if (selectedItem.value && selectedItem.value.game_interest) {
      const interest = selectedItem.value.game_interest;
      return Array.isArray(interest)
        ? interest
        : JSON.parse(interest);
    }
    return [];
  } catch (err) {
    return [];
  }
});

const parsedChildren = computed(() => {
    try {
    if (selectedItem.value && selectedItem.value.children) {
      const child = selectedItem.value.children;
      return Array.isArray(child)
        ? child
        : JSON.parse(child);
    }
    return [];
  } catch (err) {
    return [];
  }
});

const paginatedData = computed(() => {
    const start = (currentPage.value - 1) * pageSize;
    return dataList.value.slice(start, start + pageSize);
});

// Pagination methods
function goToPage(page) {
    if (page >= 1 && page <= totalPages.value) {
        currentPage.value = page;
    }
}

function prevPage() {
    if (currentPage.value > 1) {
        currentPage.value--;
    }
}

function nextPage() {
    if (currentPage.value < totalPages.value) {
        currentPage.value++;
    }
}

// Action methods
const uploadProfileImage = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    updateMessga.value = 'Uploading photo. Please wait...';
    const formData = new FormData();
    formData.append("passport", file);
    formData.append("application_id", selectedItem.value.application_id); // Or whatever your userID is

    fetch("https://api.lagoslawntennisclub1895.com/api/v1/update_profile_image.php", {
      method: "POST",
      body: formData
    })
    .then(res => res.json())
    .then(data => {
      if (data.status) {
        alert("Profile Image Updated Successfully!");
        updateMessga.value = ''
        window.location.reload();

        // Refresh image immediately
        this.selectedItem.passport = data.newImagePath;
      } else {
        alert("Failed: " + data.message);
      }
    })
    .catch(err => console.error(err));
}


const addChild = () =>{
    if (!selectedItem.value.children) {
      selectedItem.value.children = [];
    }
    selectedItem.value.children.push({
      name: '',
      sex: '',
      dob: ''
    });
  }
  
  const removeChild = (index)=> {
    selectedItem.value.children.splice(index, 1);
  }
  
 const handleFileUpload = (event, fieldName) => {
    const file = event.target.files[0];
    if (file) {
      // Handle file upload logic here
      // You might want to upload to server and update the selectedItem
      console.log(`Uploading ${fieldName}:`, file.name);
      
      // For demonstration, just update the filename
      // In a real app, you'd upload and get the new path
      selectedItem.value[fieldName] = file.name;
    }
  }

const listRecords = async () => {
  try {
    const response = await axios.post('/list_myapplications.php', { username: username.value });
    if (response.data.status) dataList.value = response.data.data;
    else console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

function viewItem(data) {
    selectedItem.value = data;
    showModal.value = true;
}
function editItem(data) {
    selectedItem.value = data;
    showEditModal.value = true;
}
function closeModal() {
  showModal.value = false;
}
function closeEditModal() {
  showEditModal.value = false;
}
const updateData = async()=>{
    // Your logic to save the updated data
    try {
    const response = await axios.post("/update_profile.php", {
      form_data: selectedItem.value,
      headers: { "Content-Type": "multipart/form-data" }
    });

    alert("✅ " + response.data.message);
    
     // Close modal after saving
     closeEditModal();

  } catch (error) {
    console.error(error);
    alert(error.response ? error.response.data.message : error.message);
  }
   
}
function approveItem(item) {
  // You can trigger an API call here to approve the record
  showModal.value = false;
}
const payment = (item) => {
  if (confirm("You will be redirected to our payment page... " + item.firstname + "?")) {
        // do nothing
    }
}
function deleteItem(dataList) {
    if (confirm("Delete " + dataList.name + "?")) {
        dataList.value = dataList.value.filter((i) => i.id !== dataList.id);
    }
}
</script>

<style lang="scss" scoped>

.modal-content {
  border-radius: 12px;
  overflow-y: auto;
  max-height: 750px;
}
.btn-secondary{
    width: 80px !important;
}
.btn-success{
    width: 100px !important;
}
.modal-header {
  padding: 1rem 1.5rem;
}

.modal-body label {
  font-size: 0.85rem;
}

.modal-body p {
  font-size: 0.95rem;
}

.badge {
  font-size: 0.85rem;
  padding: 0.5em 0.8em;
  border-radius: 6px;
}

.setup-container {
    min-height: 100vh;
    padding: 24px;

}
.application-title{
    text-align: left;
}
/* Header: Setup button + search bar */
.header-search {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    width: 100%;
    margin-bottom: 16px;
}

/* Search bar */
.search-bar {
    display: flex;
    align-items: center;
    gap: 8px;
    border: 1px solid #CED4DA;
    border-radius: 8px;
    padding: 8px 12px;
    flex: 1 1 200px;
    /* allows shrinking */
    max-width: 350px;
}

.search-bar input {
    border: none;
    outline: none;
    width: 100%;
    font-size: 16px;
}

/* Table styles */
.table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 16px;
    border-radius: 8px;
    overflow-x: auto;
}

.table thead {
    display: table-header-group;
}

.table tbody {
    display: table-row-group;
}

.table th,
.table td {
    border: 1px solid #E9ECEF;
    border-radius: 8px;
    box-shadow: #6C757D33 0px 1px 3px 0px, #6C757D1A 0px 1px 2px 0px;
    padding: 12px 16px;
    text-align: left;
    font-size: 14px;
}

.table th {
    background: #fff;
    color: #6C757D;
}

.actions {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
}

.setup-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    background-color: #fff;
    color: #DB6813;
    border: 1px solid #DB6813;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
}

/* Buttons */
.btn {
    width: 36px;
    height: 36px;
    border: 1px solid #CED4DA;
    border-radius: 8px;
    color: #343A40;
    background: white;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
}

.btn:hover {
    border: 1px solid #0DCAF0;
    color: #0DCAF0;
}

.btn .icon {
    width: 18px;
    height: 18px;
}

/* Pagination */
.pagination {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 12px;
}

.pagination button {
    width: 36px;
    height: 36px;
    border: 1px solid #CED4DA;
    border-radius: 8px;
    color: #343A40;
    background: white;
    cursor: pointer;
}

.pagination button.active {
    border: 1px solid #0057FC;
    color: #0057FC;
}

.pagination button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background-color: #E9ECEF;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
    .setup-container {
        padding: 12px;
    }

    .table th,
    .table td {
        padding: 8px 10px;
        font-size: 12px;
    }

    .search-bar {
        flex: 1 1 100%;
        margin-top: 8px;
    }

    .setup-btn {
        padding: 6px 10px;
        font-size: 12px;
    }

    .btn {
        width: 32px;
        height: 32px;
    }

    .btn .icon {
        width: 16px;
        height: 16px;
    }

    .pagination button {
        width: 32px;
        height: 32px;
        font-size: 12px;
    }

    /* Make table scrollable on mobile */
    .table {
        display: block;
        overflow-x: auto;
        white-space: nowrap;
    }
}
</style>
